var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    fill: "#484888",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-522q69 0 116.5-50.5T644-694v-126H316v126q0 71 47.5 121.5T480-522ZM160-80v-60h96v-127q0-70 36.5-128.5T394-480q-65-26-101.5-85T256-694v-126h-96v-60h640v60h-96v126q0 70-36.5 129T566-480q65 26 101.5 84.5T704-267v127h96v60H160Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassDown);
export default __webpack_public_path__ + "static/media/hourglass-down.3e6b8e26463d093e92b58662d0f63b89.svg";
export { ForwardRef as ReactComponent };